import { AuthenticationError } from "../errors";
import { DATA_SOURCE_WORKSHEET_NAME } from "../globalValues";

const API_KEY_ADDRESS = "K1:K2";

export const getAPIKey = async (context: Excel.RequestContext) => {
  const sheet = context.workbook.worksheets.getItem(DATA_SOURCE_WORKSHEET_NAME);
  const apiKeyRange = sheet.getRange(API_KEY_ADDRESS);
  apiKeyRange.load("values");
  await context.sync();

  const apiKey = apiKeyRange.values[1][0];

  if (!apiKey) {
    throw new AuthenticationError("API Key Error", "API Key is empty");
  }

  return apiKey;
};

export const addAPIKeyToWorksheet = async (
  context: Excel.RequestContext,
  apiKey: string
): Promise<AuthenticationError | void> => {
  if (!apiKey) {
    throw new AuthenticationError("API Key Error", "API Key is empty. Cannot be added");
  }

  const worksheet = context.workbook.worksheets.getItem(DATA_SOURCE_WORKSHEET_NAME);
  const range = worksheet.getRange(API_KEY_ADDRESS);

  range.values = [["API Key"], [apiKey]];
  worksheet.getRange("K:K").columnHidden = true;
};
